import {query, call} from './calls';

export const Meeting = {
    list: () => query("SELECT *, dateFormat(toDate(startDate), 'dd/MM/yyyy') as dateFormat FROM Meeting ORDER BY startDate DESC"),
    search: (q) => query(`SELECT title, id FROM Meeting WHERE title like '${q}'`),
    getAssociatedMeetings: (associatedMeetingId) => query(`SELECT * FROM Meeting WHERE id=${associatedMeetingId}`),
    getId: (meetingId) => query(`SELECT * FROM Meeting WHERE id=${meetingId}`),
    create: (values) => call("/Meeting", "POST", values),
    evaluator: (evaluator) => query(`SELECT *, dateFormat(toDate(startDate), 'dd/MM/yyyy') as dateFormat FROM Meeting ${evaluator} ORDER BY startDate DESC`)
};